import client from './client'
import type { DashboardStats } from '@/types/dashboard'

export async function fetchDashboardStats(organisationId: number): Promise<DashboardStats> {
  const { data } = await client.get<{ data: DashboardStats }>(
    `/organizer/organisations/${organisationId}/dashboard/stats`,
  )
  return data.data
}
